import $ from 'jquery';
import videojs from 'video.js';

class CMuteToggle extends videojs.getComponent('MuteToggle') {
  constructor(player, options) {
    super(player, options);
    const vol = this.player_.volume();
    let ariaPressedStatus;

    this.removeClass('vjs-mute-control');
    this.addClass('c-vjs-button');

    if (vol === 0 || this.player_.muted()) {
      this.el_.innerHTML = '<span class="cif-2x cif-fw cif-volume-off"></span>';
      ariaPressedStatus = true;
    } else if (vol < 0.33) {
      this.el_.innerHTML = '<span class="cif-2x cif-fw cif-volume-down"></span>';
      ariaPressedStatus = false;
    } else {
      this.el_.innerHTML = '<span class="cif-2x cif-fw cif-volume-up"></span>';
      ariaPressedStatus = false;
    }
    this.eventBusEl_.setAttribute('aria-pressed', ariaPressedStatus);
    this.eventBusEl_.removeAttribute('aria-disabled');
  }

  updateIcon_() {
    const vol = this.player_.volume();
    const controlIcon = $(this.el_).find('span.cif-fw');
    const controlVolumeIcon = $(this.el_);

    if (vol === 0 || this.player_.muted()) {
      controlIcon.removeClass('cif-volume-up');
      controlIcon.removeClass('cif-volume-down');
      controlIcon.addClass('cif-volume-off');
      controlVolumeIcon.attr('aria-pressed', true);
    } else if (vol < 0.33) {
      controlIcon.removeClass('cif-volume-up');
      controlIcon.removeClass('cif-volume-off');
      controlIcon.addClass('cif-volume-down');
      controlVolumeIcon.attr('aria-pressed', false);
    } else {
      controlIcon.removeClass('cif-volume-down');
      controlIcon.removeClass('cif-volume-off');
      controlIcon.addClass('cif-volume-up');
      controlVolumeIcon.attr('aria-pressed', false);
    }
  }
}

videojs.registerComponent('CMuteToggle', CMuteToggle);
